const countries = [
  {
    CCA2: 'AF',
    name: 'Afghanistan',
    CCA3: 'AFG',
    nationality: 'Afghan',
    continent: 'Asia',
  },
  {
    CCA2: 'AL',
    name: 'Albania',
    CCA3: 'ALB',
    nationality: 'Albanian',
    continent: 'Europe',
  },
  {
    CCA2: 'DZ',
    name: 'Algeria',
    CCA3: 'DZA',
    nationality: 'Algerian',
    continent: 'Africa',
  },
  {
    CCA2: 'AS',
    name: 'American Samoa',
    CCA3: 'ASM',
    nationality: 'American Samoan',
    continent: 'Australia',
  },
  {
    CCA2: 'AD',
    name: 'Andorra',
    CCA3: 'AND',
    nationality: 'Andorran',
    continent: 'Europe',
  },
  {
    CCA2: 'AO',
    name: 'Angola',
    CCA3: 'AGO',
    nationality: 'Angolan',
    continent: 'Africa',
  },
  {
    CCA2: 'AI',
    name: 'Anguilla',
    CCA3: 'AIA',
    nationality: 'Anguillian',
    continent: 'North America',
  },
  {
    CCA2: 'AG',
    name: 'Antigua and Barbuda',
    CCA3: 'ATG',
    nationality: 'Antiguan, Barbudan',
    continent: 'North America',
  },
  {
    CCA2: 'AR',
    name: 'Argentina',
    CCA3: 'ARG',
    nationality: 'Argentinean',
    continent: 'South America',
  },
  {
    CCA2: 'AM',
    name: 'Armenia',
    CCA3: 'ARM',
    nationality: 'Armenian',
    continent: 'Asia',
  },
  {
    CCA2: 'AW',
    name: 'Aruba',
    CCA3: 'ABW',
    nationality: 'Aruban',
    continent: 'North America',
  },
  {
    CCA2: 'AU',
    name: 'Australia',
    CCA3: 'AUS',
    nationality: 'Australian',
    continent: 'Australia',
  },
  {
    CCA2: 'AT',
    name: 'Austria',
    CCA3: 'AUT',
    nationality: 'Austrian',
    continent: 'Europe',
  },
  {
    CCA2: 'AZ',
    name: 'Azerbaijan',
    CCA3: 'AZE',
    nationality: 'Azerbaijani',
    continent: 'Europe',
  },
  {
    CCA2: 'BS',
    name: 'Bahamas',
    CCA3: 'BHS',
    nationality: 'Bahamian',
    continent: 'North America',
  },
  {
    CCA2: 'BH',
    name: 'Bahrain',
    CCA3: 'BHR',
    nationality: 'Bahraini',
    continent: 'Asia',
  },
  {
    CCA2: 'BD',
    name: 'Bangladesh',
    CCA3: 'BGD',
    nationality: 'Bangladeshi',
    continent: 'Asia',
  },
  {
    CCA2: 'BB',
    name: 'Barbados',
    CCA3: 'BRB',
    nationality: 'Barbadian',
    continent: 'North America',
  },
  {
    CCA2: 'BY',
    name: 'Belarus',
    CCA3: 'BLR',
    nationality: 'Belarusian',
    continent: 'Europe',
  },
  {
    CCA2: 'BE',
    name: 'Belgium',
    CCA3: 'BEL',
    nationality: 'Belgian',
    continent: 'Europe',
  },
  {
    CCA2: 'BZ',
    name: 'Belize',
    CCA3: 'BLZ',
    nationality: 'Belizean',
    continent: 'North America',
  },
  {
    CCA2: 'BJ',
    name: 'Benin',
    CCA3: 'BEN',
    nationality: 'Beninese',
    continent: 'Africa',
  },
  {
    CCA2: 'BM',
    name: 'Bermuda',
    CCA3: 'BMU',
    nationality: 'Bermudian',
    continent: 'North America',
  },
  {
    CCA2: 'BT',
    name: 'Bhutan',
    CCA3: 'BTN',
    nationality: 'Bhutanese',
    continent: 'Asia',
  },
  {
    CCA2: 'BO',
    name: 'Bolivia',
    CCA3: 'BOL',
    nationality: 'Bolivian',
    continent: 'South America',
  },
  {
    CCA2: 'BA',
    name: 'Bosnia and Herzegovina',
    CCA3: 'BIH',
    nationality: 'Bosnian, Herzegovinian',
    continent: 'Europe',
  },
  {
    CCA2: 'BW',
    name: 'Botswana',
    CCA3: 'BWA',
    nationality: 'Motswana',
    continent: 'Africa',
  },
  {
    CCA2: 'BR',
    name: 'Brazil',
    CCA3: 'BRA',
    nationality: 'Brazilian',
    continent: 'South America',
  },
  {
    CCA2: 'IO',
    name: 'British Indian Ocean Territory',
    CCA3: 'IOT',
    nationality: 'Indian',
    continent: 'Asia',
  },
  {
    CCA2: 'BN',
    name: 'Brunei Darussalam',
    CCA3: 'BRN',
    nationality: 'Bruneian',
    continent: 'Asia',
  },
  {
    CCA2: 'BG',
    name: 'Bulgaria',
    CCA3: 'BGR',
    nationality: 'Bulgarian',
    continent: 'Europe',
  },
  {
    CCA2: 'BF',
    name: 'Burkina Faso',
    CCA3: 'BFA',
    nationality: 'Burkinabe',
    continent: 'Africa',
  },
  {
    CCA2: 'BI',
    name: 'Burundi',
    CCA3: 'BDI',
    nationality: 'Burundian',
    continent: 'Africa',
  },
  {
    CCA2: 'KH',
    name: 'Cambodia',
    CCA3: 'KHM',
    nationality: 'Cambodian',
    continent: 'Asia',
  },
  {
    CCA2: 'CM',
    name: 'Cameroon',
    CCA3: 'CMR',
    nationality: 'Cameroonian',
    continent: 'Africa',
  },
  {
    CCA2: 'CA',
    name: 'Canada',
    CCA3: 'CAN',
    nationality: 'Canadian',
    continent: 'North America',
  },
  {
    CCA2: 'CV',
    name: 'Cape Verde Islands',
    CCA3: 'CPV',
    nationality: 'Cape Verdian',
    continent: 'Africa',
  },
  {
    CCA2: 'KY',
    name: 'Cayman Islands',
    CCA3: 'CYM',
    nationality: 'Caymanian',
    continent: 'North America',
  },
  {
    CCA2: 'CF',
    name: 'Central African Republic',
    CCA3: 'CAF',
    nationality: 'Central African',
    continent: 'Africa',
  },
  {
    CCA2: 'TD',
    name: 'Chad',
    CCA3: 'TCD',
    nationality: 'Chadian',
    continent: 'Africa',
  },
  {
    CCA2: 'CL',
    name: 'Chile',
    CCA3: 'CHL',
    nationality: 'Chilean',
    continent: 'South America',
  },
  {
    CCA2: 'CN',
    name: 'China',
    CCA3: 'CHN',
    nationality: 'Chinese',
    continent: 'Asia',
  },
  {
    CCA2: 'CX',
    name: 'Christmas Island',
    CCA3: 'CXR',
    nationality: 'Christmas Island',
    continent: 'Asia',
  },
  {
    CCA2: 'CC',
    name: 'Cocos [Keeling] Islands',
    CCA3: 'CCK',
    nationality: 'Cocos Islander',
    continent: 'Asia',
  },
  {
    CCA2: 'CO',
    name: 'Colombia',
    CCA3: 'COL',
    nationality: 'Colombian',
    continent: 'South America',
  },
  {
    CCA2: 'KM',
    name: 'Comoros',
    CCA3: 'COM',
    nationality: 'Comoran',
    continent: 'Africa',
  },
  {
    CCA2: 'CD',
    name: 'Congo - Kinshasa',
    CCA3: 'COD',
    nationality: 'Congolese',
    continent: 'Africa',
  },
  {
    CCA2: 'CG',
    name: 'Congo - Brazzaville',
    CCA3: 'COG',
    nationality: 'Congolese',
    continent: 'Africa',
  },
  {
    CCA2: 'CK',
    name: 'Cook Islands',
    CCA3: 'COK',
    nationality: 'Cook Islander',
    continent: 'Australia',
  },
  {
    CCA2: 'CR',
    name: 'Costa Rica',
    CCA3: 'CRI',
    nationality: 'Costa Rican',
    continent: 'North America',
  },
  {
    CCA2: 'CI',
    name: 'Ivory Coast',
    CCA3: 'CIV',
    nationality: 'Ivorian',
    continent: 'Africa',
  },
  {
    CCA2: 'CW',
    name: 'Curaçao ',
    CCA3: 'CUW',
    nationality: 'Curaçao ',
    continent: 'North America',
  },
  {
    CCA2: 'HR',
    name: 'Croatia',
    CCA3: 'HRV',
    nationality: 'Croatian',
    continent: 'Europe',
  },
  {
    CCA2: 'CU',
    name: 'Cuba',
    CCA3: 'CUB',
    nationality: 'Cuban',
    continent: 'North America',
  },
  {
    CCA2: 'CY',
    name: 'Cyprus',
    CCA3: 'CYP',
    nationality: 'Cypriot',
    continent: 'Europe',
  },
  {
    CCA2: 'CZ',
    name: 'Czech Republic',
    CCA3: 'CZE',
    nationality: 'Czech',
    continent: 'Europe',
  },
  {
    CCA2: 'DK',
    name: 'Denmark',
    CCA3: 'DNK',
    nationality: 'Danish',
    continent: 'Europe',
  },
  {
    CCA2: 'DJ',
    name: 'Djibouti',
    CCA3: 'DJI',
    nationality: 'Djibouti',
    continent: 'Africa',
  },
  {
    CCA2: 'DM',
    name: 'Dominica',
    CCA3: 'DMA',
    nationality: 'Dominican',
    continent: 'North America',
  },
  {
    CCA2: 'DO',
    name: 'Dominican Republic',
    CCA3: 'DOM',
    nationality: 'Dominican',
    continent: 'North America',
  },
  {
    CCA2: 'EC',
    name: 'Ecuador',
    CCA3: 'ECU',
    nationality: 'Ecuadorean',
    continent: 'South America',
  },
  {
    CCA2: 'EG',
    name: 'Egypt',
    CCA3: 'EGY',
    nationality: 'Egyptian',
    continent: 'Africa',
  },
  {
    CCA2: 'SV',
    name: 'El Salvador',
    CCA3: 'SLV',
    nationality: 'Salvadoran',
    continent: 'North America',
  },
  {
    CCA2: 'GQ',
    name: 'Equatorial Guinea',
    CCA3: 'GNQ',
    nationality: 'Equatorial Guinean',
    continent: 'Africa',
  },
  {
    CCA2: 'ER',
    name: 'Eritrea',
    CCA3: 'ERI',
    nationality: 'Eritrean',
    continent: 'Africa',
  },
  {
    CCA2: 'EE',
    name: 'Estonia',
    CCA3: 'EST',
    nationality: 'Estonian',
    continent: 'Europe',
  },
  {
    CCA2: 'ET',
    name: 'Ethiopia',
    CCA3: 'ETH',
    nationality: 'Ethiopian',
    continent: 'Africa',
  },
  {
    CCA2: 'FK',
    name: 'Falkland Islands',
    CCA3: 'FLK',
    nationality: 'Falkland Islander',
    continent: 'South America',
  },
  {
    CCA2: 'FO',
    name: 'Faroe Islands',
    CCA3: 'FRO',
    nationality: 'Faroese',
    continent: 'Europe',
  },
  {
    CCA2: 'FJ',
    name: 'Fiji',
    CCA3: 'FJI',
    nationality: 'Fijian',
    continent: 'Australia',
  },
  {
    CCA2: 'FI',
    name: 'Finland',
    CCA3: 'FIN',
    nationality: 'Finnish',
    continent: 'Europe',
  },
  {
    CCA2: 'FR',
    name: 'France',
    CCA3: 'FRA',
    nationality: 'French',
    continent: 'Europe',
  },
  {
    CCA2: 'GF',
    name: 'French Guiana',
    CCA3: 'GUF',
    nationality: 'French Guiana',
    continent: 'South America',
  },
  {
    CCA2: 'PF',
    name: 'French Polynesia',
    CCA3: 'PYF',
    nationality: 'French Polynesian',
    continent: 'Australia',
  },
  {
    CCA2: 'GA',
    name: 'Gabon',
    CCA3: 'GAB',
    nationality: 'Gabonese',
    continent: 'Africa',
  },
  {
    CCA2: 'GM',
    name: 'Gambia',
    CCA3: 'GMB',
    nationality: 'Gambian',
    continent: 'Africa',
  },
  {
    CCA2: 'GE',
    name: 'Georgia',
    CCA3: 'GEO',
    nationality: 'Georgian',
    continent: 'Europe',
  },
  {
    CCA2: 'DE',
    name: 'Germany',
    CCA3: 'DEU',
    nationality: 'German',
    continent: 'Europe',
  },
  {
    CCA2: 'GH',
    name: 'Ghana',
    CCA3: 'GHA',
    nationality: 'Ghanaian',
    continent: 'Africa',
  },
  {
    CCA2: 'GI',
    name: 'Gibraltar',
    CCA3: 'GIB',
    nationality: 'Gibraltar',
    continent: 'Europe',
  },
  {
    CCA2: 'GR',
    name: 'Greece',
    CCA3: 'GRC',
    nationality: 'Greek',
    continent: 'Europe',
  },
  {
    CCA2: 'GL',
    name: 'Greenland',
    CCA3: 'GRL',
    nationality: 'Greenlandic',
    continent: 'North America',
  },
  {
    CCA2: 'GD',
    name: 'Grenada',
    CCA3: 'GRD',
    nationality: 'Grenadian',
    continent: 'North America',
  },
  {
    CCA2: 'GP',
    name: 'Guadeloupe',
    CCA3: 'GLP',
    nationality: 'Guadeloupian',
    continent: 'North America',
  },
  {
    CCA2: 'GU',
    name: 'Guam',
    CCA3: 'GUM',
    nationality: 'Guamanian',
    continent: 'Australia',
  },
  {
    CCA2: 'GT',
    name: 'Guatemala',
    CCA3: 'GTM',
    nationality: 'Guatemalan',
    continent: 'North America',
  },
  {
    CCA2: 'GG',
    name: 'Guernsey',
    CCA3: 'GGY',
    nationality: 'Channel Islander',
    continent: 'Europe',
  },
  {
    CCA2: 'GN',
    name: 'Guinea',
    CCA3: 'GIN',
    nationality: 'Guinean',
    continent: 'Africa',
  },
  {
    CCA2: 'GW',
    name: 'Guinea - Bissau',
    CCA3: 'GNB',
    nationality: 'Guinea-Bissauan',
    continent: 'Africa',
  },
  {
    CCA2: 'GY',
    name: 'Guyana',
    CCA3: 'GUY',
    nationality: 'Guyanese',
    continent: 'South America',
  },
  {
    CCA2: 'HT',
    name: 'Haiti',
    CCA3: 'HTI',
    nationality: 'Haitian',
    continent: 'North America',
  },
  {
    CCA2: 'HN',
    name: 'Honduras',
    CCA3: 'HND',
    nationality: 'Honduran',
    continent: 'North America',
  },
  {
    CCA2: 'HK',
    name: 'Hong Kong SAR China',
    CCA3: 'HKG',
    nationality: 'Chinese',
    continent: 'Asia',
  },
  {
    CCA2: 'HU',
    name: 'Hungary',
    CCA3: 'HUN',
    nationality: 'Hungarian',
    continent: 'Europe',
  },
  {
    CCA2: 'IS',
    name: 'Iceland',
    CCA3: 'ISL',
    nationality: 'Icelander',
    continent: 'Europe',
  },
  {
    CCA2: 'IN',
    name: 'India',
    CCA3: 'IND',
    nationality: 'Indian',
    continent: 'Asia',
  },
  {
    CCA2: 'ID',
    name: 'Indonesia',
    CCA3: 'IDN',
    nationality: 'Indonesian',
    continent: 'Asia',
  },
  {
    CCA2: 'IR',
    name: 'Iran',
    CCA3: 'IRN',
    nationality: 'Iranian',
    continent: 'Asia',
  },
  {
    CCA2: 'IQ',
    name: 'Iraq',
    CCA3: 'IRQ',
    nationality: 'Iraqi',
    continent: 'Asia',
  },
  {
    CCA2: 'IE',
    name: 'Ireland',
    CCA3: 'IRL',
    nationality: 'Irish',
    continent: 'Europe',
  },
  {
    CCA2: 'IM',
    name: 'Isle of Man',
    CCA3: 'IMN',
    nationality: 'Manx',
    continent: 'Europe',
  },
  {
    CCA2: 'IL',
    name: 'Israel',
    CCA3: 'ISR',
    nationality: 'Israeli',
    continent: 'Asia',
  },
  {
    CCA2: 'IT',
    name: 'Italy',
    CCA3: 'ITA',
    nationality: 'Italian',
    continent: 'Europe',
  },
  {
    CCA2: 'JM',
    name: 'Jamaica',
    CCA3: 'JAM',
    nationality: 'Jamaican',
    continent: 'North America',
  },
  {
    CCA2: 'JP',
    name: 'Japan',
    CCA3: 'JPN',
    nationality: 'Japanese',
    continent: 'Asia',
  },
  {
    CCA2: 'JE',
    name: 'Jersey',
    CCA3: 'JEY',
    nationality: 'Channel Islander',
    continent: 'Europe',
  },
  {
    CCA2: 'JO',
    name: 'Jordan',
    CCA3: 'JOR',
    nationality: 'Jordanian',
    continent: 'Asia',
  },
  {
    CCA2: 'KZ',
    name: 'Kazakhstan',
    CCA3: 'KAZ',
    nationality: 'Kazakhstani',
    continent: 'Asia',
  },
  {
    CCA2: 'KE',
    name: 'Kenya',
    CCA3: 'KEN',
    nationality: 'Kenyan',
    continent: 'Africa',
  },
  {
    CCA2: 'KI',
    name: 'Kiribati',
    CCA3: 'KIR',
    nationality: 'I-Kiribati',
    continent: 'Australia',
  },
  {
    CCA2: 'KW',
    name: 'Kuwait',
    CCA3: 'KWT',
    nationality: 'Kuwaiti',
    continent: 'Asia',
  },
  {
    CCA2: 'KG',
    name: 'Kyrgyzstan',
    CCA3: 'KGZ',
    nationality: 'Kirghiz',
    continent: 'Asia',
  },
  {
    CCA2: 'LA',
    name: 'Laos',
    CCA3: 'LAO',
    nationality: 'Laotian',
    continent: 'Asia',
  },
  {
    CCA2: 'LV',
    name: 'Latvia',
    CCA3: 'LVA',
    nationality: 'Latvian',
    continent: 'Europe',
  },
  {
    CCA2: 'LB',
    name: 'Lebanon',
    CCA3: 'LBN',
    nationality: 'Lebanese',
    continent: 'Asia',
  },
  {
    CCA2: 'LS',
    name: 'Lesotho',
    CCA3: 'LSO',
    nationality: 'Mosotho',
    continent: 'Africa',
  },
  {
    CCA2: 'LR',
    name: 'Liberia',
    CCA3: 'LBR',
    nationality: 'Liberian',
    continent: 'Africa',
  },
  {
    CCA2: 'LY',
    name: 'Libya',
    CCA3: 'LBY',
    nationality: 'Libyan',
    continent: 'Africa',
  },
  {
    CCA2: 'LI',
    name: 'Liechtenstein',
    CCA3: 'LIE',
    nationality: 'Liechtensteiner',
    continent: 'Europe',
  },
  {
    CCA2: 'LT',
    name: 'Lithuania',
    CCA3: 'LTU',
    nationality: 'Lithuanian',
    continent: 'Europe',
  },
  {
    CCA2: 'LU',
    name: 'Luxembourg',
    CCA3: 'LUX',
    nationality: 'Luxembourger',
    continent: 'Europe',
  },
  {
    CCA2: 'MO',
    name: 'Macau SAR China',
    CCA3: 'MAC',
    nationality: 'Chinese',
    continent: 'Asia',
  },
  {
    CCA2: 'MG',
    name: 'Madagascar',
    CCA3: 'MDG',
    nationality: 'Malagasy',
    continent: 'Africa',
  },
  {
    CCA2: 'MW',
    name: 'Malawi',
    CCA3: 'MWI',
    nationality: 'Malawian',
    continent: 'Africa',
  },
  {
    CCA2: 'MY',
    name: 'Malaysia',
    CCA3: 'MYS',
    nationality: 'Malaysian',
    continent: 'Asia',
  },
  {
    CCA2: 'MV',
    name: 'Maldives',
    CCA3: 'MDV',
    nationality: 'Maldivan',
    continent: 'Asia',
  },
  {
    CCA2: 'ML',
    name: 'Mali',
    CCA3: 'MLI',
    nationality: 'Malian',
    continent: 'Africa',
  },
  {
    CCA2: 'MT',
    name: 'Malta',
    CCA3: 'MLT',
    nationality: 'Maltese',
    continent: 'Europe',
  },
  {
    CCA2: 'MH',
    name: 'Marshall Islands',
    CCA3: 'MHL',
    nationality: 'Marshallese',
    continent: 'Australia',
  },
  {
    CCA2: 'MQ',
    name: 'Martinique',
    CCA3: 'MTQ',
    nationality: 'French',
    continent: 'North America',
  },
  {
    CCA2: 'MR',
    name: 'Mauritania',
    CCA3: 'MRT',
    nationality: 'Mauritanian',
    continent: 'Africa',
  },
  {
    CCA2: 'MU',
    name: 'Mauritius',
    CCA3: 'MUS',
    nationality: 'Mauritian',
    continent: 'Africa',
  },
  {
    CCA2: 'YT',
    name: 'Mayotte',
    CCA3: 'MYT',
    nationality: 'French',
    continent: 'Africa',
  },
  {
    CCA2: 'MX',
    name: 'Mexico',
    CCA3: 'MEX',
    nationality: 'Mexican',
    continent: 'North America',
  },
  {
    CCA2: 'FM',
    name: 'Micronesia',
    CCA3: 'FSM',
    nationality: 'Micronesian',
    continent: 'Australia',
  },
  {
    CCA2: 'MD',
    name: 'Moldova',
    CCA3: 'MDA',
    nationality: 'Moldovan',
    continent: 'Europe',
  },
  {
    CCA2: 'MC',
    name: 'Monaco',
    CCA3: 'MCO',
    nationality: 'Monegasque',
    continent: 'Europe',
  },
  {
    CCA2: 'MN',
    name: 'Mongolia',
    CCA3: 'MNG',
    nationality: 'Mongolian',
    continent: 'Asia',
  },
  {
    CCA2: 'ME',
    name: 'Montenegro',
    CCA3: 'MNE',
    nationality: 'Montenegrin',
    continent: 'Europe',
  },
  {
    CCA2: 'MS',
    name: 'Montserrat',
    CCA3: 'MSR',
    nationality: 'Montserratian',
    continent: 'North America',
  },
  {
    CCA2: 'MA',
    name: 'Morocco',
    CCA3: 'MAR',
    nationality: 'Moroccan',
    continent: 'Africa',
  },
  {
    CCA2: 'MZ',
    name: 'Mozambique',
    CCA3: 'MOZ',
    nationality: 'Mozambican',
    continent: 'Africa',
  },
  {
    CCA2: 'MM',
    name: 'Myanmar [Burma]',
    CCA3: 'MMR',
    nationality: 'Myanmar',
    continent: 'Asia',
  },
  {
    CCA2: 'NA',
    name: 'Namibia',
    CCA3: 'NAM',
    nationality: 'Namibian',
    continent: 'Africa',
  },
  {
    CCA2: 'NR',
    name: 'Nauru',
    CCA3: 'NRU',
    nationality: 'Nauruan',
    continent: 'Australia',
  },
  {
    CCA2: 'NP',
    name: 'Nepal',
    CCA3: 'NPL',
    nationality: 'Nepalese',
    continent: 'Asia',
  },
  {
    CCA2: 'NL',
    name: 'Netherlands',
    CCA3: 'NLD',
    nationality: 'Dutch',
    continent: 'Europe',
  },
  {
    CCA2: 'NC',
    name: 'New Caledonia',
    CCA3: 'NCL',
    nationality: 'New Caledonian',
    continent: 'Australia',
  },
  {
    CCA2: 'NZ',
    name: 'New Zealand',
    CCA3: 'NZL',
    nationality: 'New Zealander',
    continent: 'Australia',
  },
  {
    CCA2: 'NI',
    name: 'Nicaragua',
    CCA3: 'NIC',
    nationality: 'Nicaraguan',
    continent: 'North America',
  },
  {
    CCA2: 'NE',
    name: 'Niger',
    CCA3: 'NER',
    nationality: 'Nigerian',
    continent: 'Africa',
  },
  {
    CCA2: 'NG',
    name: 'Nigeria',
    CCA3: 'NGA',
    nationality: 'Nigerian',
    continent: 'Africa',
  },
  {
    CCA2: 'NU',
    name: 'Niue',
    CCA3: 'NIU',
    nationality: 'Niuean',
    continent: 'Australia',
  },
  {
    CCA2: 'KP',
    name: 'North Korea',
    CCA3: 'PRK',
    nationality: 'North Korean',
    continent: 'Asia',
  },
  {
    CCA2: 'MK',
    name: 'North Macedonia',
    CCA3: 'MKD',
    nationality: 'North Macedonian',
    continent: 'Europe',
  },
  {
    CCA2: 'NO',
    name: 'Norway',
    CCA3: 'NOR',
    nationality: 'Norwegian',
    continent: 'Europe',
  },
  {
    CCA2: 'OM',
    name: 'Oman',
    CCA3: 'OMN',
    nationality: 'Omani',
    continent: 'Asia',
  },
  {
    CCA2: 'PK',
    name: 'Pakistan',
    CCA3: 'PAK',
    nationality: 'Pakistani',
    continent: 'Asia',
  },
  {
    CCA2: 'PW',
    name: 'Palau',
    CCA3: 'PLW',
    nationality: 'Palauan',
    continent: 'Australia',
  },
  {
    CCA2: 'PS',
    name: 'Palestinian Territories',
    CCA3: 'PSE',
    nationality: 'Palestinian',
    continent: 'Asia',
  },
  {
    CCA2: 'PA',
    name: 'Panama',
    CCA3: 'PAN',
    nationality: 'Panamanian',
    continent: 'North America',
  },
  {
    CCA2: 'PG',
    name: 'Papua New Guinea',
    CCA3: 'PNG',
    nationality: 'Papua New Guinean',
    continent: 'Australia',
  },
  {
    CCA2: 'PY',
    name: 'Paraguay',
    CCA3: 'PRY',
    nationality: 'Paraguayan',
    continent: 'South America',
  },
  {
    CCA2: 'PE',
    name: 'Peru',
    CCA3: 'PER',
    nationality: 'Peruvian',
    continent: 'South America',
  },
  {
    CCA2: 'PH',
    name: 'Philippines',
    CCA3: 'PHL',
    nationality: 'Filipino',
    continent: 'Asia',
  },
  {
    CCA2: 'PN',
    name: 'Pitcairn Islands',
    CCA3: 'PCN',
    nationality: 'Pitcairn Islander',
    continent: 'Australia',
  },
  {
    CCA2: 'PL',
    name: 'Poland',
    CCA3: 'POL',
    nationality: 'Polish',
    continent: 'Europe',
  },
  {
    CCA2: 'PT',
    name: 'Portugal',
    CCA3: 'PRT',
    nationality: 'Portuguese',
    continent: 'Europe',
  },
  {
    CCA2: 'PR',
    name: 'Puerto Rico',
    CCA3: 'PRI',
    nationality: 'Puerto Rican',
    continent: 'South America',
  },
  {
    CCA2: 'QA',
    name: 'Qatar',
    CCA3: 'QAT',
    nationality: 'Qatari',
    continent: 'Asia',
  },
  {
    CCA2: 'RE',
    name: 'Réunion',
    CCA3: 'REU',
    nationality: 'French',
    continent: 'Africa',
  },
  {
    CCA2: 'RO',
    name: 'Romania',
    CCA3: 'ROU',
    nationality: 'Romanian',
    continent: 'Europe',
  },
  {
    CCA2: 'RU',
    name: 'Russia',
    CCA3: 'RUS',
    nationality: 'Russian',
    continent: 'Europe',
  },
  {
    CCA2: 'RW',
    name: 'Rwanda',
    CCA3: 'RWA',
    nationality: 'Rwandan',
    continent: 'Africa',
  },
  {
    CCA2: 'KN',
    name: 'Saint Kitts and Nevis',
    CCA3: 'KNA',
    nationality: 'Kittian and Nevisian',
    continent: 'North America',
  },
  {
    CCA2: 'LC',
    name: 'Saint Lucia',
    CCA3: 'LCA',
    nationality: 'Saint Lucian',
    continent: 'North America',
  },
  {
    CCA2: 'MF',
    name: 'Saint Martin',
    CCA3: 'MAF',
    nationality: 'Saint Martin Islander',
    continent: 'North America',
  },
  {
    CCA2: 'VC',
    name: 'Saint Vincent and the Grenadines',
    CCA3: 'VCT',
    nationality: 'Saint Vincentian',
    continent: 'North America',
  },
  {
    CCA2: 'WS',
    name: 'Samoa',
    CCA3: 'WSM',
    nationality: 'Samoan',
    continent: 'Australia',
  },
  {
    CCA2: 'SM',
    name: 'San Marino',
    CCA3: 'SMR',
    nationality: 'Sammarinese',
    continent: 'Europe',
  },
  {
    CCA2: 'ST',
    name: 'São Tomé and Príncipe',
    CCA3: 'STP',
    nationality: 'Sao Tomean',
    continent: 'Africa',
  },
  {
    CCA2: 'SA',
    name: 'Saudi Arabia',
    CCA3: 'SAU',
    nationality: 'Saudi Arabian',
    continent: 'Asia',
  },
  {
    CCA2: 'SN',
    name: 'Senegal',
    CCA3: 'SEN',
    nationality: 'Senegalese',
    continent: 'Africa',
  },
  {
    CCA2: 'RS',
    name: 'Serbia',
    CCA3: 'SRB',
    nationality: 'Serbian',
    continent: 'Europe',
  },
  {
    CCA2: 'SC',
    name: 'Seychelles',
    CCA3: 'SYC',
    nationality: 'Seychellois',
    continent: 'Africa',
  },
  {
    CCA2: 'SL',
    name: 'Sierra Leone',
    CCA3: 'SLE',
    nationality: 'Sierra Leonean',
    continent: 'Africa',
  },
  {
    CCA2: 'SG',
    name: 'Singapore',
    CCA3: 'SGP',
    nationality: 'Singaporean',
    continent: 'Asia',
  },
  {
    CCA2: 'SK',
    name: 'Slovakia',
    CCA3: 'SVK',
    nationality: 'Slovak',
    continent: 'Europe',
  },
  {
    CCA2: 'SI',
    name: 'Slovenia',
    CCA3: 'SVN',
    nationality: 'Slovene',
    continent: 'Europe',
  },
  {
    CCA2: 'SB',
    name: 'Solomon Islands',
    CCA3: 'SLB',
    nationality: 'Solomon Islander',
    continent: 'Australia',
  },
  {
    CCA2: 'SO',
    name: 'Somalia',
    CCA3: 'SOM',
    nationality: 'Somali',
    continent: 'Africa',
  },
  {
    CCA2: 'ZA',
    name: 'South Africa',
    CCA3: 'ZAF',
    nationality: 'South African',
    continent: 'Africa',
  },
  {
    CCA2: 'KR',
    name: 'South Korea',
    CCA3: 'KOR',
    nationality: 'South Korean',
    continent: 'Asia',
  },
  {
    CCA2: 'ES',
    name: 'Spain',
    CCA3: 'ESP',
    nationality: 'Spanish',
    continent: 'Europe',
  },
  {
    CCA2: 'LK',
    name: 'Sri Lanka',
    CCA3: 'LKA',
    nationality: 'Sri Lankan',
    continent: 'Asia',
  },
  {
    CCA2: 'SD',
    name: 'Sudan',
    CCA3: 'SDN',
    nationality: 'Sudanese',
    continent: 'Africa',
  },
  {
    CCA2: 'SR',
    name: 'Suriname',
    CCA3: 'SUR',
    nationality: 'Surinamer',
    continent: 'South America',
  },
  {
    CCA2: 'SZ',
    name: 'Swaziland',
    CCA3: 'SWZ',
    nationality: 'Swazi',
    continent: 'Africa',
  },
  {
    CCA2: 'SE',
    name: 'Sweden',
    CCA3: 'SWE',
    nationality: 'Swedish',
    continent: 'Europe',
  },
  {
    CCA2: 'CH',
    name: 'Switzerland',
    CCA3: 'CHE',
    nationality: 'Swiss',
    continent: 'Europe',
  },
  {
    CCA2: 'SY',
    name: 'Syria',
    CCA3: 'SYR',
    nationality: 'Syrian',
    continent: 'Asia',
  },
  {
    CCA2: 'TW',
    name: 'Taiwan',
    CCA3: 'TWN',
    nationality: 'Taiwanese',
    continent: 'Asia',
  },
  {
    CCA2: 'TJ',
    name: 'Tajikistan',
    CCA3: 'TJK',
    nationality: 'Tadzhik',
    continent: 'Asia',
  },
  {
    CCA2: 'TZ',
    name: 'Tanzania',
    CCA3: 'TZA',
    nationality: 'Tanzanian',
    continent: 'Africa',
  },
  {
    CCA2: 'TH',
    name: 'Thailand',
    CCA3: 'THA',
    nationality: 'Thai',
    continent: 'Asia',
  },
  {
    CCA2: 'TL',
    name: 'Timor - Leste',
    CCA3: 'TLS',
    nationality: 'East Timorese',
    continent: 'Asia',
  },
  {
    CCA2: 'TG',
    name: 'Togo',
    CCA3: 'TGO',
    nationality: 'Togolese',
    continent: 'Africa',
  },
  {
    CCA2: 'TK',
    name: 'Tokelau',
    CCA3: 'TKL',
    nationality: 'Tokelauan',
    continent: 'Australia',
  },
  {
    CCA2: 'TO',
    name: 'Tonga',
    CCA3: 'TON',
    nationality: 'Tongan',
    continent: 'Australia',
  },
  {
    CCA2: 'TT',
    name: 'Trinidad and Tobago',
    CCA3: 'TTO',
    nationality: 'Trinidadian',
    continent: 'North America',
  },
  {
    CCA2: 'TN',
    name: 'Tunisia',
    CCA3: 'TUN',
    nationality: 'Tunisian',
    continent: 'Africa',
  },
  {
    CCA2: 'TR',
    name: 'Turkey',
    CCA3: 'TUR',
    nationality: 'Turkish',
    continent: 'Asia',
  },
  {
    CCA2: 'TM',
    name: 'Turkmenistan',
    CCA3: 'TKM',
    nationality: 'Turkmen',
    continent: 'Asia',
  },
  {
    CCA2: 'TC',
    name: 'Turks and Caicos Islands',
    CCA3: 'TCA',
    nationality: 'Turks and Caicos Islander',
    continent: 'North America',
  },
  {
    CCA2: 'TV',
    name: 'Tuvalu',
    CCA3: 'TUV',
    nationality: 'Tuvaluan',
    continent: 'Australia',
  },
  {
    CCA2: 'UG',
    name: 'Uganda',
    CCA3: 'UGA',
    nationality: 'Ugandan',
    continent: 'Africa',
  },
  {
    CCA2: 'UA',
    name: 'Ukraine',
    CCA3: 'UKR',
    nationality: 'Ukrainian',
    continent: 'Europe',
  },
  {
    CCA2: 'AE',
    name: 'United Arab Emirates',
    CCA3: 'ARE',
    nationality: 'Emirati',
    continent: 'Asia',
  },
  {
    CCA2: 'GB',
    name: 'United Kingdom',
    CCA3: 'GBR',
    nationality: 'British',
    continent: 'Europe',
  },
  {
    CCA2: 'US',
    name: 'United States',
    CCA3: 'USA',
    nationality: 'American',
    continent: 'North America',
  },
  {
    CCA2: 'UY',
    name: 'Uruguay',
    CCA3: 'URY',
    nationality: 'Uruguayan',
    continent: 'South America',
  },
  {
    CCA2: 'UZ',
    name: 'Uzbekistan',
    CCA3: 'UZB',
    nationality: 'Uzbekistani',
    continent: 'Asia',
  },
  {
    CCA2: 'VU',
    name: 'Vanuatu',
    CCA3: 'VUT',
    nationality: 'Ni-Vanuatu',
    continent: 'Australia',
  },
  {
    CCA2: 'VA',
    name: 'Vatican City',
    CCA3: 'VAT',
    nationality: 'Italian',
    continent: 'Europe',
  },
  {
    CCA2: 'VE',
    name: 'Venezuela',
    CCA3: 'VEN',
    nationality: 'Venezuelan',
    continent: 'South America',
  },
  {
    CCA2: 'VN',
    name: 'Vietnam',
    CCA3: 'VNM',
    nationality: 'Vietnamese',
    continent: 'Asia',
  },
  {
    CCA2: 'VG',
    name: 'Virgin Islands British',
    CCA3: 'VGB',
    nationality: 'Virgin Islander',
    continent: 'North America',
  },
  {
    CCA2: 'VI',
    name: 'Virgin Islands U.S.',
    CCA3: 'VIR',
    nationality: 'Virgin Islander',
    continent: 'North America',
  },
  {
    CCA2: 'WF',
    name: 'Wallis and Futuna Islands',
    CCA3: 'WLF',
    nationality: 'Wallis and Futuna Islander',
    continent: 'Australia',
  },
  {
    CCA2: 'EH',
    name: 'Western Sahara',
    CCA3: 'ESH',
    nationality: 'Sahrawi',
    continent: 'Africa',
  },
  {
    CCA2: 'YE',
    name: 'Yemen',
    CCA3: 'YEM',
    nationality: 'Yemeni',
    continent: 'Asia',
  },
  {
    CCA2: 'ZM',
    name: 'Zambia',
    CCA3: 'ZMB',
    nationality: 'Zambian',
    continent: 'Africa',
  },
  {
    CCA2: 'ZW',
    name: 'Zimbabwe',
    CCA3: 'ZWE',
    nationality: 'Zimbabwean',
    continent: 'Africa',
  },
];

export default countries;
